import React from "react";
import CourseCategoryPage from "../components/CourseCategoryPage";
import { getScuba } from "../services/api";

function Scuba() {
  return (
    <CourseCategoryPage
      queryKey="scuba"
      fetchFn={getScuba}
      popupStorageKey="scubapage_popup_dismissed_this_tab"
      errorMessage="Failed to load scuba courses."
    />
  );
}

export default Scuba;
